<template>
  <div class="modal-window large split active" id="print-contract">
    <overlay-scrollbars :options="{ className: 'custom-scrollbar os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
      <TheLoader :small="true" :active="$store.getters.isFormLoading"/>
      <form @submit.prevent="handleSubmit">
        <div class="grid-x split">
          <div class="cell large-6 flex-column">
            <div class="modal-window-header gray">
              <div class="modal-window-heading">
                <h3 class="icon-heading small">
                  <span class="icon"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-print"></use></svg></span>
                  <span class="icon-heading-title">
                    <span class="title" v-if="bilag">
                      {{invoiceTitle}} #{{invoiceNumber}}
                    </span>
                  </span>
                </h3>
              </div>
            </div>

            <div class="modal-window-body">
              <fieldset>
                <div class="grid-x grid-padding-x">
                  <TheTextInput v-model.trim="emailData.from_name" autofill="off" autocomplete="off" containerClassName="cell medium-6" :label="'Avsender'" :placeholder="'Avsender navn…'" name="email_from_name" required v-validate="nameRule"/>
                  <TheEmailInput v-model.trim="emailData.from_mail" autofill="off" autocomplete="off" containerClassName="cell medium-6" :label="'Avsender e-post'" :placeholder="'Avsender e-post…'" name="email_from_mail" required v-validate="mailRule"/>

                  <TheSwitchInput v-model="emailData.send_bcc" containerClassName="cell" :small="true" labelTrue="Send kopi til avsender" labelFalse="Send kopi til avsender" :trueValue="true" :falseValue="false"/>

                  <TheTextInput v-model.trim="emailData.to_name" autofill="off" autocomplete="off" containerClassName="cell medium-6" :label="'Mottaker'" :placeholder="'Mottaker navn…'" name="email_to_name" required v-validate="nameRule"/>
                  <TheEmailInput v-model.trim="emailData.to_mail" autofill="off" autocomplete="off" containerClassName="cell medium-6" :label="'Mottaker e-post'" :placeholder="'Mottaker e-post…'" name="email_to_mail" required v-validate="mailRule"/>

                  <TheTextInput v-model.trim="emailData.subject" containerClassName="cell medium-12" :label="'Emne'" :placeholder="'Emne…'" name="email_subject" required v-validate="subjectRule"/>
                  <TheTextArea v-model="emailData.content" containerClassName="cell medium-12" :label="'Tekst'" :placeholder="'E-post tekst…'" name="email_content"  :rows="3" required v-validate="contentRule"/>
                </div>
              </fieldset>
              <div class="split" style="padding-bottom: 10px">
                <img v-if="barcode" alt="Strekode" :src="barcode" />
              </div>
            </div>

            <div class="modal-window-footer">
              <div class="grid-x">
                <div class="cell align-right">
                  <a v-if="!$store.getters.isFormProcessing" href="javascript:;" @click="closeButtonClick()" class="button primary transparent large modal-close show-for-medium">Avbryt</a>
                  <a v-else href="javascript:;" class="button primary transparent large modal-close show-for-medium">Avbryt</a>

                  <template v-if="pdfSource">
                    <a v-if="$store.getters.isFormSubmittable" href="javascript:;" @click="emailButtonClick()" class="button primary submit large">Send til kunde</a>
                    <a v-if="$store.getters.isFormProcessing" href="javascript:;" class="button primary submit large loading">Sender til kunde...<span class="loader-spinner"></span></a>
                    <a v-if="$store.getters.isFormLoading" href="javascript:;" class="button primary submit large" disabled>Send til kunde</a>
                  </template>
                  <template v-else>
                    <a v-if="$store.getters.isFormSubmittable" href="javascript:;" class="button primary submit large" disabled>Send til kunde</a>
                    <a v-if="$store.getters.isFormProcessing" href="javascript:;" class="button primary submit large loading" disabled>Sender til kunde...<span class="loader-spinner"></span></a>
                    <a v-if="$store.getters.isFormLoading" href="javascript:;" class="button primary submit large" disabled>Send til kunde</a>
                  </template>
                </div>
              </div>
            </div>
          </div>

          <div class="cell large-6 flex-column">
            <div class="modal-window-body no-padding">

              <div v-if="pdfSource" class="iframe-container pdf">
                <iframe id="pdfFrame" name="pdfFrame" frameborder="0" marginwidth="0" marginheight="0" scrolling="no" :src="pdfSource + '#view=FitH&toolbar=1'"></iframe>
                <!-- <iframe v-if="pdfSource" id="pdfFrame" name="pdfFrame" frameborder="0" marginwidth="0" marginheight="0" scrolling="no" :src="pdfSource + '#view=FitH&toolbar=1'"></iframe>
                <TheEmptyList v-if="!pdfSource && !$store.getters.isFormProcessing" :title="'Opprett ' + printType" :message="'Trykk på Oprett PDF for å se forhåndsvisning og skrive ut ' + printType" :large="false" :icon="'button-glyph-contract'"/>
                <TheLoader :active="!pdfSource && $store.getters.isFormProcessing"/> -->
              </div>

              <div v-else style="text-align: center; width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;">
                <span v-if="loadingPdfAttempt <= loadingPdfAttemptsMax">
                  <h4 style="display: block; margin-top: -5rem;">
                    Prøver å laste ned pdf fra 24SO.
                    <div style="font-size: 0.8rem;" class="opacity-60" v-if="loadingPdfAttempt > 0">Forsøk {{loadingPdfAttempt}} / {{loadingPdfAttemptsMax}}</div>
                  </h4>

                  <TheLoader :small="true" :active="loadingPdf" :update="true"/>
                </span>
                <span v-else-if="!loadingPdf">
                  <h4 style="display: block; margin-top: -5rem;">
                    Kunne ikke finne noen PDF hos 24SO.
                    <div style="font-size: 0.8rem;" class="opacity-60">Forsøk selv igjen om en liten stund...</div>
                  </h4>
                  <br>
                  <button class="button primary" type="button" @click="fetchPdf">Prøv igen...</button>
                </span>
                <span v-else>
                  <h4 style="display: block; margin-top: -5rem;">
                    Kunne ikke finne noen PDF hos 24SO
                    <div style="font-size: 0.8rem;" class="opacity-60">Forsøk selv igjen om en liten stund...</div>
                  </h4>
                  <br>
                  <button class="button primary loading" type="button" >Prøver igjen...<span class="loader-spinner"></span></button>
                </span>
              </div>
            </div>
          </div>
        </div>

        <a v-if="!pdfSource" href="javascript:;" class="modal-close modal-window-close-button" @click="closeButtonClick()">
          <span>Lukk</span>
          <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-close"></use></svg>
        </a>
      </form>
    </overlay-scrollbars>
  </div>
</template>

<script>
import BilagService from '@/services/BilagService'
import KundeService from '../../services/KundeService'

export default {
  name: 'KundeKontraktCreateModal',
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    query: {
      type: [String, Object],
      required: true
    },
    creditMode: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      loadingPdf: false,
      loadingPdfTimeout: null,
      loadingPdfAttempt: 0,
      loadingPdfAttemptsMax: 5,
      loadingPdfAttemptsInterval: 5000,
      bilag: null,
      emailData: {},
      pdfSource: false,
      barcode: false
    }
  },
  created () {
    // Load bilag
    this.init()

    /**
     * HELP
     *
     * EO: https://bqdrift.atlassian.net/wiki/spaces/AD/pages/548995083/EO+Invoice
     * @return bilag
     *
     */
  },
  mounted () {
    window.jQuery('.modal-window-body').attr('tabindex', -1).css({outline: 'none'}).focus()
  },
  beforeDestroy: function () {
    // Clear timeout on destroy
    if (this.loadingPdfTimeout) {
      clearTimeout(this.loadingPdfTimeout)
    }
  },
  computed: {
    nameRule: function () {
      return this.pdfSource ? 'required|max:100' : ''
    },
    mailRule: function () {
      return this.pdfSource ? 'required|email' : ''
    },
    subjectRule: function () {
      return this.pdfSource ? 'required|max:50' : ''
    },
    contentRule: function () {
      return this.pdfSource ? 'required' : ''
    },
    invoiceTitle: function () {
      if (this.bilag) {
        return this.bilag.Bilagstype === 'F' ? 'Faktura' : 'Kreditnota'
      }

      return null
    },
    invoiceNumber: function () {
      if (this.bilag) {
        return this.bilag.twentyfourseven_invoice_id && this.bilag.Dato > '2019-12-31'
          ? this.bilag.twentyfourseven_invoice_id
          : this.bilag.Bilagsnr
      }

      return null
    }
  },
  watch: {
    bilag: function (newVal) {
      if (newVal) {
        this.setupEmailData()
        this.fetchPdf()
      }
    }
  },
  methods: {
    init: function () {
      this.setFormLoading(true)

      const qtype = typeof this.query

      if (!this.query) {
        // Handle error, if no query is sent to the component
        this.setFormLoading(false)
        this.$helpers.showErrorAlert('Feil', 'Fant ingen bilag å vise')
        this.$emit('close')
      } else if (qtype === 'string') {
        // Load bilag by Bilagsid
        BilagService.getBilag(this.query)
          .then(response => {
            this.bilag = response.data
          })
          .catch(err => {
            console.log('Error', err)
            this.$helpers.showErrorAlert('Feil', 'Fant ingen bilag å vise')
            this.$emit('close')
          })
          .then(() => {
            this.setFormLoading(false)
          })
      } else if (qtype === 'object') {
        if (this.query.Bilagsid) {
          this.bilag = this._.cloneDeep(this.query)
        } else {
          this.$helpers.showErrorAlert('Feil', 'Fant ingen bilag å vise')
          this.$emit('close')
        }

        this.setFormLoading(false)
      }
    },
    fetchPdf: function () {
      const vm = this

      this.loadingPdf = true

      ++this.loadingPdfAttempt
      KundeService.getKundeBilagStrekkode(this.bilag.Bilagsid)
        .then((response) => {
          if (response.data) {
            let url = process.env.VUE_APP_AVANTI_API_URL + response.data
            this.barcode = url
          }
        })
        .catch((error) => {
          console.log('Error')
          console.log(error)
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke finne strekoden')
        })
        .then(() => {
          this.setFormLoading(false)
        })
      BilagService.getBilagPdf(this.bilag.Bilagsid)
        .then(response => {
          this.pdfSource = process.env.VUE_APP_AVANTI_API_URL + response.data
        })
        .catch(err => {
          console.log('No pdf found for any reason...')
          console.log(err)
        })
        .then(() => {
          this.loadingPdf = false

          if (vm.loadingPdfAttempt >= vm.loadingPdfAttemptsMax) {
            if (vm.loadingPdfTimeout) {
              clearTimeout(vm.loadingPdfTimeout)
            }

            setTimeout(function () {
              ++vm.loadingPdfAttempt
            }, 500)
          } else if (!vm.pdfSource) {
            vm.loadingPdfTimeout = setTimeout(vm.fetchPdf, vm.loadingPdfAttemptsInterval)
          }
        })
    },
    setupEmailData: function () {
      const temp = {
        from_mail: this.$store.getters.getUser.Email || '',
        from_name: this.$store.getters.getUser.full_name || '',
        to_mail: this.bilag.Email || '',
        to_name: this.bilag.Navn || '',
        to_kundenr: this.bilag.Kundenr,
        subject: 'Blomqvist ' + this.invoiceTitle + ' #' + this.invoiceNumber,
        send_bcc: false
      }

      temp.content = `Kjære kunde

Vedlagt finner du din ` + this.invoiceTitle + `.

Takk for at du benytter Blomqvist.

Vennlig hilsen
` + (temp.from_name ? temp.from_name : 'Kontraktsansvarlig') + `



Dear client

Please find your invoice attached to this email.

Thank you for using Blomqvist.

Best regards
` + (temp.from_name ? temp.from_name : 'Kontraktsansvarlig')

      // Add to the vue variable...
      this.emailData = Object.assign({}, temp)
    },
    closeButtonClick: function () {
      if (!this.$store.getters.isFormProcessing) {
        this.$emit('close')
      }
    },
    emailButtonClick: function () {
      this.handleSubmit()
    },
    handleSubmit: function () {
      if (!this.isFormSubmittable()) {
        return
      }

      this.setFormProcessing(true)

      if (this.emailData.content) {
        this.emailData.content = this.emailData.content.trim()
      }

      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            // Validation Failed
            this.setFormProcessing(false)
            this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst korriger feil i skjemaet')
          } else {
            const vm = this
            const post = {
              email: this.emailData
            }

            BilagService.sendBilagPdf(this.bilag.Bilagsid, post)
              .then(response => {
                this.$helpers.showSuccessAlert('Fakturaen har blitt sendt')

                // Reload kundehistory
                vm.$store.dispatch('kundehistory/load', vm.bilag.Kundenr)

                setTimeout(function () {
                  vm.closeModal()
                }, 1500)
              })
              .catch(error => {
                console.log('Error', error)
                this.$helpers.showErrorAlert('Feil', 'Kunne ikke sende faktura')
              })
              .then(() => {
                // sdsdd
                this.setFormProcessing(false)
              })
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/BilagEmailPdfModal.vue